export function requireConnection(): void {
    if (navigator.onLine === false) throw new Error("Connection required");
}
